import React from 'react';
import { BaasicDropdown, Loader } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const ExportLabelsTemplate = ({
	exportLabelsViewStore: { loading, exportLabels, carrierTypeServiceTypeDropdownStore },
	t,
}) => {
	if (loading) return <Loader />;
	return (
		<React.Fragment>
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">{t('FULFILLMENTORDER.EXPORTLABELSMODAL.TITLE')}</h3>
			</div>
			<div className="ReactModal__body">
				<BaasicDropdown
					dropdownStore={carrierTypeServiceTypeDropdownStore}
					className="spc--bottom--sml flex--grow--1"
				/>
			</div>
			<div className="ReactModal__footer">
				<button
					type="button"
					className="btn btn--med btn--primary spc--bottom--sml"
					disabled={carrierTypeServiceTypeDropdownStore.value == null}
					onClick={exportLabels}
				>
					{t('CONFIRM')}
				</button>
			</div>
		</React.Fragment>
	);
};

export default defaultTemplate(ExportLabelsTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/ExportLabelsTemplate.jsx